import { useTranslation } from "react-i18next";

import { SNOOZE_STATUSES } from "models";
import { enumToDropdownOptions } from "utils/common";

export const useSnoozeStatusOptions = () => {
  const { t } = useTranslation();
  const selectAllOption = { key: "all", value: "all", text: t("v8_all", "All") };
  const deleteOption = { key: SNOOZE_STATUSES.Deleted, value: SNOOZE_STATUSES.Deleted, text: t("v8_deleted", "Deleted") };

  return { snoozeStatusOptions: [selectAllOption, ...enumToDropdownOptions({ enumObj: SNOOZE_STATUSES, t, keysToExclude: ["Deleted"] }), deleteOption] };
};
